import React from 'react'
import { CNavItem } from '@coreui/react'

import _modules from '../../../../_modules'
import products from '../../../../collectionsStructure/trading-products'

let output = []

if (_modules.products) {
  output.push({
    component: CNavItem,
    name: 'Products',
    to: '/products',
    permissionSource: products.permissionSource,
    icon: <i className="material-icons-outlined">shop</i>,
  })
}

export default output
